import React from "react";
import Icons from "../../../../Config/Images";
import Fonts from "../../../../Config/Fonts";
import Colors from "../../../../theme/Colors";
import { transportStatus } from "../../../../Constants/AppConstants";

const TransportBody = ({
  transportDetails,
  onViewTransportDetails,
  onEditTransportDetails,
  handleShowDeleteModal,
}) => {

  return (
    <tbody>
      {transportDetails?.map((transport, index) => (
        <tr key={index}>
          <td component="th" style={tableDataInputStyle}>
            {index + 1}
          </td>
          <td component="th" style={tableDataInputStyle}>
            {transport?.transport_name || "-"}
          </td>
          <td component="th" style={tableDataInputStyle}>
            {transport?.transport_head_office_city || "-"}
          </td>
          <td component="th" style={tableDataInputStyle}>
            {transport?.transport_mobile_number || "-"}
          </td>
          <td component="th" style={tableDataInputStyle}>
            {transport?.transport_alternate_mobile_number || "-"}
          </td>
          <td component="th" style={tableDataInputStyle}>
            {transport?.transport_service_number || "-"}
          </td>
          <div
              style={{
                color: transportStatus[transport?.transport_status]?.color || "#181818",
                padding: "13px 5px",
                borderRadius: "4px",
                textAlign: "center",
                fontSize:"14px",
                border:"1px solid #E6E6E6",
              }}
            >
              {transportStatus[transport?.transport_status]?.label || "N/A"}
            </div>
          <td align="right" style={tableDataInputStyle}>
            <img
              src={Icons.viewIcon}
              style={{
                height: "20px",
                width: "22px",
                cursor: "pointer",
              }}
              onClick={() => onViewTransportDetails(transport)}
              alt="Preview Icon"
            />
            <img
              src={Icons.editIcon}
              style={{
                height: "20px",
                width: "20px",
                cursor: "pointer",
                marginLeft: "20px",
              }}
              onClick={() => onEditTransportDetails(transport)}
              alt="edit Icon"
            />
            <img
              src={Icons.trashIcon}
              style={{
                height: "20px",
                width: "20px",
                cursor: "pointer",
                marginLeft: "20px",
              }}
              onClick={() => handleShowDeleteModal(transport)}
              alt="Delete Icon"
            />
          </td>
        </tr>
      ))}
    </tbody>
  );
};
const tableDataInputStyle = {
  fontSize: 12,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  textAlign: "center",
  padding: "8px 10px",
  border: "1px solid #E6E6E6",
};

export default TransportBody;
